import Constantes from './Constantes';

class Fetch {

  static setFonctionDeco(deco) {
    this.deco = deco;
  }

  static getFonctionDeco() {
    this.deco();
  }

  static requete(data, reussite) {

    var controller = new AbortController();
    var signal = controller.signal;
    var myHeaders = new Headers({
      'Accept': 'application/json',
      "Content-Type": "application/json",
      'Authorization': `BEARER ${localStorage.getItem('token') || ''}`
    });

    var myInit = {
      method: data.method || "POST",
      headers: myHeaders,
      signal
    };

    if (myInit.method !== 'GET') {
      myInit.body = JSON.stringify(data.data || {});
    }


    fetch(`${Constantes.url}v1${data.url}`, myInit)
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          console.error(`${Constantes.url}v1${data.url}`, response);
          throw (response);
        }
      })
      .then(dataJSON => {
        if (reussite) {
          reussite(dataJSON);
        }
      })
      .catch(function (err) {
        console.error(`Erreur ${data.url} ${err.status} ${err.statusText}`);

        if (err.status === 401) {
          Fetch.getFonctionDeco();
        } else {
          reussite();
        }

      });

    const abort = () => {
      controller.abort();
    }

    return { abort };
  }


}

export default Fetch;